import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-password-request',
  templateUrl: './password-request.component.html',
  styleUrl: './password-request.component.scss',
})
export class PasswordRequestComponent {
  email = '';
  loading = false;
  sent = false;
  error = '';

  /**
   * The account exists but its registration was never confirmed. A reset link
   * would not help: the password would be set and the login would still
   * refuse it. The confirmation mail is the way out, so offer it here.
   */
  unconfirmed = false;
  resendLoading = false;
  resendSuccess = false;
  resendError = '';

  constructor(private router: Router, private authService: AuthService) {}

  submit(): void {
    if (!this.email || this.loading) {
      return;
    }
    this.loading = true;
    this.error = '';
    this.unconfirmed = false;

    this.authService.requestPasswordReset(this.email).subscribe({
      next: () => {
        this.loading = false;
        this.sent = true;
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        const code = err.headers?.get('X-Error-Code') ?? '';

        if (code === 'account_unconfirmed') {
          this.unconfirmed = true;
          return;
        }

        // Whether an address has an account is not something this page
        // should confirm to whoever types it, so an unknown address reads
        // exactly like a successful request.
        if (err.status === 404 || err.status === 400) {
          this.sent = true;
          return;
        }

        this.error = 'pages.passwordRequest.error';
      },
    });
  }

  resendConfirmation(): void {
    if (this.resendLoading) {
      return;
    }
    this.resendLoading = true;
    this.resendError = '';

    this.authService.resendConfirmation(this.email).subscribe({
      next: () => {
        this.resendLoading = false;
        this.resendSuccess = true;
      },
      error: (err: HttpErrorResponse) => {
        this.resendLoading = false;
        // 429 is the resend cooldown, not a failure. Saying "could not
        // be sent" would tell someone to give up at the exact moment
        // they only have to wait a minute.
        this.resendError =
          err?.status === 429
            ? 'pages.passwordRequest.resendCooldown'
            : 'pages.passwordRequest.resendError';
      },
    });
  }

  toLogin(): void {
    this.router.navigate(['/auth/login']);
  }
}
